import { classNames } from '@/shared/lib/classNames/classNames';

interface CasesStaticCardWithImageProps {
  title: string;
  description: string;
  image: string;
  className?: string;
  variant?: 'vertical' | 'horizontal';
}

export const CasesStaticCardWithImage = ({
  title,
  description,
  image,
  className,
  variant = 'horizontal',
}: CasesStaticCardWithImageProps) => {
  return (
    <div
      className={classNames({
        cls: 'bg-surface-base-secondary flex w-full gap-5 rounded-[20px] p-7 max-sm:flex-col-reverse max-sm:gap-5 max-sm:p-6',
        mods: {
          'flex-col': variant === 'vertical',
        },
        additional: [className],
      })}
    >
      <div className="flex-1">
        <p className="text-text-base-primary typo-heading-m">{title}</p>

        <p className="text-text-base-secondary mt-2 text-[16px] leading-[28px] font-normal max-sm:text-[16px] max-sm:leading-[24px]">
          {description}
        </p>
      </div>

      <img
        src={image}
        alt="card"
        className={classNames({
          cls: 'h-[158px] w-[293px] min-w-[293px] rounded-[14px] object-cover max-sm:h-[158px] max-sm:w-full',
          mods: {
            'h-[124px] w-full': variant === 'vertical',
          },
        })}
      />
    </div>
  );
};
